export const TRUTH_CHALLENGE_PROMPTS = [
  'a cat with main-character energy',
  'armor that looks alive',
  'someone deeply unimpressed',
  'a storm swallowing the landscape',
  'gold made for a ceremony',
  'the moon as the main character',
  'a pattern so dense it becomes abstract',
  'a figure caught in a strange gesture',
  'cold water and an empty horizon',
  'an ancient object that feels futuristic',
  'flowers arranged like a secret code',
  'a sacred scene with theatrical lighting'
] as const;
